"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStock = updateStock;
async function updateStock(machineRepo, machineId, micronAisleId, aisleCode, currStock) {
    return await machineRepo.updateStock(machineId, micronAisleId, aisleCode, currStock);
}
